import ThemeProvider from '@rezdy/components/ThemeWrapper';
import React, { Suspense } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import GlobalStyles from './components/GlobalStyles';
import routes from './constants/routes';
import ErrorBoundary from './components/ErrorBoundary';
import { pages } from './pages';
import routing from './services/routing';
import gmt from './services/gmt';
import LoadingDots from './components/LoadingDots';

const renderPage = (Component: any) => (
    // Wrap component in suspense to handle i18n backend loads
    <Suspense fallback={<LoadingDots />}>
        <ErrorBoundary>
            <Component />
        </ErrorBoundary>
    </Suspense>
);

class App extends React.PureComponent {
    componentDidMount() {
        gmt.render();
    }

    render() {
        return (
            <ThemeProvider>
                <React.Fragment>
                    <GlobalStyles />
                    <Router history={routing.history}>
                        <Switch>
                            {pages.map(page => (
                                <Route
                                    key={page.route}
                                    path={page.route}
                                    component={() => renderPage(page.component)}
                                />
                            ))}
                            <Redirect to={`${routing.link(routes.SIGN_IN)}`} />
                        </Switch>
                    </Router>
                </React.Fragment>
            </ThemeProvider>
        );
    }
}

export default App;
